// @ts-nocheck
import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';

import { Card } from '@/components';
import { CLASSES } from '@/constants/classes';
import SalesPeopleList from './SalesPeopleList';

export default function PreferencesSalesPeoplePage() {
  return (
    <div
      className={classNames(
        CLASSES.PREFERENCES_PAGE_INSIDE_CONTENT,
        CLASSES.PREFERENCES_PAGE_INSIDE_CONTENT_SalESPEOPLE,
      )}
    >
      <SalesPeopleCard>
        <SalesPeopleList />
      </SalesPeopleCard>
    </div>
  );
}

const SalesPeopleCard = styled(Card)`
  padding: 0;
`;
